<!-- <body class="inventory-body">
    <div class="login-container">
        <div class="" id="google-button"></div>
    </div>
</body> -->


<div class="li-page d-flex">
    <div class="vic li-left-content">
      <div class="rab app-logo-name">
        <!-- <img src="assets/images/holcim-logo.png" alt="Holcim logo"/>
        <p class="cp-str">Hint</p> -->
      </div>
    </div>
    <div class="vic li-right-content">
      <p class="gs-str">Welcome to Amrize Cement Certification Tool</p>
      <div class="hic">
        <div class="" id="google-button"></div>
      </div>
      <p class="liratp-str">
        Sign in with Google
      </p>
      <div class="hic">
        <img  src="../../assets/Amrize_tagline_h_rgb.svg" alt="logo" style="width: 150px;"/>
      </div>
    </div>
  </div>
  